import Plx from 'react-plx';
import TextScroller from '~/components/textScroller/textScroller';

const parallaxData = [
  {
    start: 'self',
    duration: 500,
    properties: [
      {
        startValue: 0.1,
        endValue: 1,
        property: 'scale',
      },
    ],
  }
];

const parallaxDataOpacity = [
  {
    start: 'self',
    duration: 500,
    properties: [
      {
        startValue: 0,
        endValue: 1,
        property: 'opacity',
      },
    ],
  }
];

/**
 * About
 * @category Functional Component
 * @extends Component
 * @summary Displays the about block.
 * @prop {object} data - The data from the parent page.
 * @return {Node} React node containing the about block.
 */

const About = (props) => {
  const { data } = props;

  return (
    <div className='about-scroller'>
      <Plx parallaxData={ parallaxData }>
        <img
          className='about__content-portrait'
          src='/img/about_drew.png'
          alt=''
          loading='lazy'
          width='395'
          height='393'
        />
      </Plx>
      <Plx parallaxData={ parallaxDataOpacity } className='plx-full'>
        <TextScroller />
      </Plx>
      { data?.about?.body &&
        <div className='constrain'>
          <div
            dangerouslySetInnerHTML={{__html: data.about.body}}
            className='about__copy'
            data-testid="about__copy"
          ></div>
          <img
            className='about__content-sig'
            src='/img/drew_sig.png'
            alt=''
            width='310'
            height='81'
            data-testid="about__content-sig"
          />
        </div>
      }
    </div>
  );
}

export default About;
